import 'zone.js';
import '@angular/localize/init';
(window as any)['global'] = window;
